import React from 'react';
import { ValidationError, useForm } from '@formspree/react';

function ContactForm() {
  const [state, handleSubmit] = useForm('mqkoawjr');
  if (state.succeeded) {
    return <p>Thanks for joining!</p>;
  }
  return (
    <div className="mt-[50px] overflow-x-hidden grid place-items-center">
      <div className=" ">
        <div className=" ">
          <div class="py-8 lg:py-16 px-4 mx-auto max-w-screen-md">
            <h2 class=" text-4xl tracking-tight font-extrabold text-center text-gray-900">
              Contact Us
            </h2>
            <p class=" lg: font-light text-center text-gray-500 dark:text-gray-400 sm:text-xl">
              Whether you need staffing solutions or are looking for your next
              career opportunity, Jobs For Us is here to help. Fill out the form
              below or contact us directly to get in touch with our team.
            </p>
          </div>
          <div className="block p-10 rounded-lg shadow-lg bg-white ">
            <form
              id="fs-frm"
              name="simple-contact-form"
              onSubmit={handleSubmit}
            >
              <div className="form-group ">
                <label htmlFor="full-name">Full Name</label>
                <input
                  id="full-name"
                  type="text"
                  name="name"
                  placeholder="John Doe"
                  className="form-control
        block
        w-full
        px-3
        py-3
        my-2
        text-base
        font-normal
        text-gray-700
        bg-white bg-clip-padding
        border border-solid border-gray-300
        rounded
        transition
        ease-in-out
        m-0"
                />
                <label htmlFor="email">Email Address</label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  placeholder="johndoe@email.com"
                  className="form-control
        block
        w-full
        px-3
        py-1.5
        my-2
        text-base
        font-normal
        text-gray-700
        bg-white bg-clip-padding
        border border-solid border-gray-300
        rounded
        transition
        ease-in-out
        m-0"
                />
                <ValidationError
                  prefix="Email"
                  field="email"
                  errors={state.errors}
                />
                <label htmlFor="telephone">Telephone Number </label>
                <input
                  type="telephone"
                  name="telephone"
                  id="telephone"
                  placeholder="(555) 555-5555"
                  className="form-control
        block
        w-full
        px-3
        py-2
        my-2
        text-base
        font-normal
        text-gray-700
        bg-white bg-clip-padding
        border border-solid border-gray-300
        rounded
        transition
        ease-in-out
        m-0"
                ></input>
                <label htmlFor="message">
                  Tell us more about your inquiry:
                </label>
                <textarea
                  rows="5"
                  id="message"
                  name="message"
                  className="form-control
        block
        w-full
        my-2
        px-3
        py-2
        text-base
        font-normal
        text-gray-700
        bg-white bg-clip-padding
        border border-solid border-gray-300
        rounded
        transition
        ease-in-out
        m-0"
                />
                <ValidationError
                  prefix="Message"
                  field="message"
                  errors={state.errors}
                />
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id="smsOptIn"
                    name="smsOptIn"
                    className="mr-2"
                  />
                  <label htmlFor="smsOptIn" className="text-gray-700">
                    SMS Opt-In Clause
                  </label>
                </div>
                <a
                  href="/privacy-policy"
                  className="text-blue-500 hover:underline block mt-2"
                >
                  Privacy Policy
                </a>
                <button
                  type="submit"
                  disabled={state.submitting}
                  className="py-4 px-12
      my-6
      bg-blue-900
      text-white
      font-medium
      text-xs
      leading-tight
      uppercase
      rounded
      shadow-md
      hover:bg-blue-700 hover:shadow-lg
      focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0
      active:bg-blue-800 active:shadow-lg
      transition
      duration-150
      ease-in-out"
                >
                  Send Inquiry
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactForm;
